@if (basket?.invokedUser?.id) {
  <div>
    <span i18n="@@inv-invokeduser">Booking For </span>
    <span id="basket-invoked-user">{{ basket.invokedUser.email }}</span>
  </div>
}
